import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ProjectSupportResponseDto } from '../dto/response/project-support-response.dto';
import projectSupportService from '../services/project-support.service';
import { ProjectSupportSaveRequestDto } from '../dto/request/project-support-save-request.dto';
import { ProjectSupportUpdateRequestDto } from '../dto/request/project-support-update-request.dto';

const initialState = {
  status: 'idle',
  projectSupports: [] as ProjectSupportResponseDto[] | null,
  projectSupport: {} as ProjectSupportResponseDto | null,
  error: null as string | null,
};

export const fetchProjectSupportsByProjectId = createAsyncThunk(
  'projectSupports/fetchProjectSupportsByProjectId',
  async (projectId: string) => {
    return await projectSupportService.fetchProjectSupportsByProjectId(
      projectId
    );
  }
);

// export const fetchProjectSupportById = createAsyncThunk(
//   'projectSupports/fetchProjectSupportById',
//   async (id: string) => {
//     return await projectSupportService.fetchProjectSupportById(id);
//   }
// );

export const saveProjectSupport = createAsyncThunk(
  'projectSupports/saveProjectSupport',
  async (saveRequest: ProjectSupportSaveRequestDto) => {
    return await projectSupportService.saveProjectSupport(saveRequest);
  }
);

export const updateProjectSupport = createAsyncThunk(
  'projectSupports/updateProjectSupport',
  async (updateRequest: ProjectSupportUpdateRequestDto) => {
    return await projectSupportService.updateProjectSupport(updateRequest);
  }
);

export const deleteProjectSupport = createAsyncThunk(
  'projectSupports/deleteProjectSupport',
  async (existingId: string) => {
    return await projectSupportService.deleteProjectSupport(existingId);
  }
);

const projectSupportSlice = createSlice({
  name: 'projectSupportSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectSupportsByProjectId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjectSupportsByProjectId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectSupports = action.payload;
      })
      .addCase(fetchProjectSupportsByProjectId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      // .addCase(fetchProjectSupportById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchProjectSupportById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.projectSupport = action.payload;
      // })
      // .addCase(fetchProjectSupportById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(saveProjectSupport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveProjectSupport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectSupports?.push(action.payload);
      })
      .addCase(saveProjectSupport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(updateProjectSupport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateProjectSupport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (state.projectSupports) {
          const projectSupportIndex = state.projectSupports.findIndex(
            (projectSupport) => projectSupport.id === action.payload.id
          );
          if (projectSupportIndex !== -1) {
            state.projectSupports[projectSupportIndex] = action.payload;
          }
        }
      })
      .addCase(updateProjectSupport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(deleteProjectSupport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteProjectSupport.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteProjectSupport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default projectSupportSlice.reducer;
